import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

/**
 * Mindful Changes Counseling of Pennsylvania theme overrides layered on top of the Optum baseline.
 *
 * Keep this config as deltas only; any token or asset omitted here
 * inherits from the default Optum theme.
 */
export const MINDCPENN_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/mindcpenn/logo.png",
        alt: "Mindful Changes Counseling of Pennsylvania Logo",
        style: {
          width: "300px",
          height: "100%",
          padding: "10px 0",
          isMobile: { width: "200px" },
        },
      },
    },
    icons: {},
  },
  providerGroupId: 31,
  state: "PA",
  departmentIds: [150, 128],
};
